import { action } from 'easy-peasy';
import { IActionUpdateTemplate } from '../types';

const updateTemplate: IActionUpdateTemplate = action((state, payload) => {
  state.items = state.items.map(item => (item.id === payload.id ? { ...item, ...payload } : item));
});

export default updateTemplate;
